var _linearGradient, _linearGradient2, _radialGradient, _radialGradient2, _radialGradient3, _radialGradient4, _path, _path2, _path3, _use, _use2, _use3, _use4, _use5, _use6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdgeBrowser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 27600 27600",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 6870,
    x2: 24704,
    xlinkHref: "none",
    y1: 18705,
    y2: 18705
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0c59a4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#114a8b"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 16272,
    x2: 5133,
    xlinkHref: "none",
    y1: 10968,
    y2: 23102
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1b9de2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#1595df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#0680d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0078d4"
  }))), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 16720,
    cy: 18747,
    r: 9538,
    xlinkHref: "none"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopOpacity: 0.53
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: 7130,
    cy: 19866,
    gradientTransform: "matrix(.14843 -.98892 .79688 .1196 -8759 25542)",
    r: 14324,
    xlinkHref: "none"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 2523,
    cy: 4680,
    gradientTransform: "matrix(-.03715 .99931 -2.12836 -.07913 13579 3530)",
    r: 20243,
    xlinkHref: "none"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#35c1f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#34c1ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2fc2df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2bc3d2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#36c752"
  }))), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 24247,
    cy: 7758,
    gradientTransform: "matrix(.28109 .95968 -.78353 .22949 24510 -16292)",
    r: 9734,
    xlinkHref: "none"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#66eb6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#66eb6e",
    stopOpacity: 0
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "g",
    d: "m24105 20053a9345 9345 0 0 1 -1053 472 10202 10202 0 0 1 -3590 646c-4732 0-8855-3255-8855-7432 0-1175 680-2193 1643-2729-4280 180-5380 4640-5380 7253 0 7387 6810 8137 8276 8137 791 0 1984-230 2704-456l130-44a12834 12834 0 0 0 6660-5282c220-350-168-757-535-565z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "h",
    d: "m11571 25141a7913 7913 0 0 1 -2273-2137 8145 8145 0 0 1 -1514-4740 8093 8093 0 0 1 3093-6395 8082 8082 0 0 1 1373-859c312-148 846-414 1554-404a3236 3236 0 0 1 2569 1297 3184 3184 0 0 1 636 1866c0-21 2446-7960-8005-7960-4390 0-8004 4166-8004 7820 0 2319 538 4170 1212 5604a12833 12833 0 0 0 7684 6757 12795 12795 0 0 0 3908 610c1414 0 2774-233 4045-656a7575 7575 0 0 1 -6278-803z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "i",
    d: "m16231 15886c-80 105-330 250-330 566 0 260 170 512 472 723 1438 1003 4149 868 4156 868a5954 5954 0 0 0 3027-839 6147 6147 0 0 0 1133-850 6180 6180 0 0 0 1910-4437c26-2242-796-3732-1133-4392-2120-4141-6694-6525-11668-6525-7011 0-12703 5635-12798 12620 47-3654 3679-6605 7996-6605 350 0 2346 34 4200 1007 1634 858 2490 1894 3086 2921 618 1067 728 2415 728 2952s-271 1333-780 1990z"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "url(#a)",
    xlinkHref: "#g"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    fill: "url(#c)",
    opacity: 0.35,
    xlinkHref: "#g"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    fill: "url(#b)",
    xlinkHref: "#h"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    fill: "url(#d)",
    opacity: 0.4,
    xlinkHref: "#h"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    fill: "url(#e)",
    xlinkHref: "#i"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    fill: "url(#f)",
    xlinkHref: "#i"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdgeBrowser);
export default __webpack_public_path__ + "static/media/edge-browser.05197f0db798cc28ea009666c04a07ac.svg";
export { ForwardRef as ReactComponent };